module.exports = __webpack_public_path__ + "media/images/pic/courses/sun-40fae61ec883622ecddd6344e38dd194.svg";